import React from 'react'
import './Skills.css'

const allSkills = [
    {
        "name": "html.svg",
        "title": "HTML"
    },
    {
        "name": "css.svg",
        "title": "CSS"
    },
    {
        "name": "js.svg",
        "title": "Javascript"
    },
    {
        "name": "react.png",
        "title": "React"
    },
    {
        "name": "chakraui.svg",
        "title": "Chakra UI"
    },
    {
        "name": "redux.svg",
        "title": "Redux"
    },
    {
        "name": "nodejs.svg",
        "title": "Node Js"
    },
    {
        "name": "mongodb.svg",
        "title": "MongoDb"
    },
    {
        "name": "express.svg",
        "title": "Express Js"
    }
]

const Skills = () => {
    return (
        <div className='skills'>
            <div className="heading">
                <h2>Skills</h2>
                <p>Below are the TechStacks that I learnt so far...</p>
            </div>
            <div className="keyskills">
                {allSkills.map(el => {
                    return <div key={el.title} className="tech">
                        <img src={require(`../../image/${el.name}`)} alt="" width={"144px"} /><br />
                        <div className='focus-content'>
                            <span>{el.title}</span>

                        </div>
                    </div>
                })}
            </div>
        </div>
    )
}

export default Skills